// The calls the signed-in review list makes, shaped as the { status, body } answers ReviewWorkspace reads. Shared by
// "Your review" (MyReviewsPage) and the workspace inside the Access reviews page.
import { api } from '../../lib/api.js';

/** A thrown API error as the { status, body } the review list reads. */
export const asAnswer = async (promise) => {
  try {
    return { status: 200, body: await promise };
  } catch (e) {
    if (!Number.isInteger(e?.status)) throw e;
    return { status: e.status, body: e.body ?? null };
  }
};

/**
 * The adapter for a signed-in customer admin. Delegate needs the campaign id (the route names it). `onRecorded` runs
 * after a decision is saved, so a page can refresh its own counts.
 */
export function signedInAdapter(customerId, view, { onRecorded } = {}) {
  const campaignId = view?.campaign?.campaignId;
  return {
    decide: async ({ decisions, bulk }) => {
      const r = await asAnswer(api.decideMyAccessReviews(customerId, { decisions, ...(bulk ? { bulk: true } : {}) }));
      if (r.status === 200 && r.body?.state === 'recorded') onRecorded?.();
      return r;
    },
    ...(campaignId ? {
      delegate: ({ itemRefs, toId, reason }) => asAnswer(api.delegateMyAccessReviews(customerId, campaignId, { itemRefs, toId, reason })),
      searchPeople: ({ q, item }) => asAnswer(api.searchAccessReviewPeople(customerId, campaignId, { q, item })),
    } : {}),
  };
}
